<div *ngIf="!apiCalling">
    <div class="header-panel bg-white">
        <nav class="navbar navbar-expand-lg w-100 navbar-light bg-white">
            <div class="container-fluid">
                <a class="navbar-brand pt-0" href="#">
                    <img class="logo mx-2" src="../../../assets/Gyan-image.png" alt="Gyan Logo" />
                    <!-- <span class="font-weight-bold section-title">Gyan</span> -->
                </a>
            </div>
        </nav>
    </div>
    <!--For desktop view-->
    <div class="vh-80 d-none d-sm-none d-md-block d-lg-block">
        <div class="container-fluid">
            <div class="row d-flex article-css">
                <div class="col-lg-12 col-md-12">
                    <main class="d-flex justify-content-center align-items-center vh-90">
                        <div class="container col-lg-6 col-md-6 bg-white d-flex justify-content-center">
                            <!-- <div class="row d-flex justify-content-center"> -->
                            <div class="col-lg-12 col-md-12 p-0">
                                <div class="card-group p-0">
                                    <div *ngIf="!apiCalling" class="card px-5 my-2 mx-1 border-0">
                                        <div class="card-body p-3 my-4">
                                            <div class="d-flex justify-content-center text-center mb-2">
                                                <h1 *ngIf="isUserVerified" class="regular-heading-text primary-color fw-semi-bold">Email Verified</h1>
                                                <h1 *ngIf="!isUserVerified" class="regular-heading-text error-color fw-semi-bold">Verification failed!</h1>
                                            </div>
                                            <div class="d-flex justify-content-center text-center mb-3">
                                                <h5 *ngIf="isUserVerified" class="mb-0">Your email address has been successfully verified!</h5>
                                                <h5 *ngIf="!isUserVerified" class="mb-0">Your email verification is failed. Please try again</h5>
                                            </div>

                                            <div *ngIf="isUserVerified" class="row d-flex justify-content-center mt-1">
                                                <button type="submit" (click)="navigateToBaseURL()" class="btn-custom w-100px btn-primary btn-custom-tags">Sign In</button>
                                            </div>
                                            <!-- <div *ngIf="isAutoLogin && isUserVerified" class="row d-flex justify-content-center mt-1">
                                                    <button type="submit" (click)="goToPortal()" class="btn-custom btn-primary btn-custom-tags">{{ 'email.go-to-portal' | translate }}</button>
                                                </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- </div> -->
                        </div>
                    </main>
                </div>
            </div>
        </div>
    </div>
    <!--For Mobile view-->
    <div class="vh-80 d-sm-block d-md-none">
        <div class="container-fluid">
            <div class="row d-flex article-css">
                <div class="col-lg-12 py-2 pr-2">
                    <main class="main d-flex align-items-center">
                        <div class="container d-flex justify-content-center">
                            <div class="row d-flex justify-content-center">
                                <div class="col-md-12 px-0">
                                    <div *ngIf="!apiCalling" class="card-group px-5">
                                        <div class="card px-5 my-2 mx-1">
                                            <div class="card-body p-3 my-4">
                                                <div class="d-flex justify-content-center text-center mb-2">
                                                    <h1 *ngIf="isUserVerified" class="regular-heading-text primary-color fw-semi-bold">{{ 'email.email-verified' | translate }}</h1>
                                                    <h1 *ngIf="!isUserVerified" class="regular-heading-text error-color fw-semi-bold">
                                                        {{ 'email.email-verification-failed' | translate }}
                                                    </h1>
                                                </div>
                                                <div class="d-flex justify-content-center text-center mb-3">
                                                    <h1 *ngIf="isUserVerified" class="mb-0">{{ 'email.email-verified-notification' | translate }}</h1>
                                                    <h1 *ngIf="!isUserVerified" class="mb-0">{{ 'email.fail-email-verified-notification' | translate }}</h1>
                                                </div>

                                                <div *ngIf="isUserVerified" class="row d-flex justify-content-center mt-1">
                                                    <button type="submit" (click)="navigateToBaseURL()" class="btn-custom btn-primary btn-custom-tags">
                                                        {{ 'email.sign_in' | translate }}
                                                    </button>
                                                </div>
                                                <!-- <div *ngIf="isAutoLogin && isUserVerified" class="row d-flex justify-content-center mt-1">
                                                    <button type="submit" (click)="goToPortal()" class="btn-custom btn-primary btn-custom-tags">{{ 'email.go-to-portal' | translate }}</button>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="apiCalling">
    <div class="d-flex justify-content-center align-items-center vh-100">
        <div class="p-5">
            <div class="d-flex">
                <div class="padding-summary">Loading..</div>
                <div><img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
            </div>
        </div>
    </div>
</div>
<app-login></app-login>
